import Vue from 'vue'
import Vuex from 'vuex'
import loading from './modulos/loading'
import loginuser from './modulos/loginuser'
import axios from 'axios'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        recarregar: false,
        requestErro: '',
        dadosEngenharia: null
    },

    mutations: {

        UPDATE_RECARREGAR(state, status) {
            state.recarregar = status
        },

        SET_REQUEST_ERROR(state, error) {
            state.requestErro = error
        },

        SET_DADOS_ENGENHARIA(state, dados) {
            state.dadosEngenharia = dados
        }
    },

    actions: {

        setRecarregar({ commit }, status) {
            commit('UPDATE_RECARREGAR', status)
        },

        setRequestError({ commit }, error) {
            commit('SET_REQUEST_ERROR', error)
        },

        setDadosEngenharia({ commit }, dados) {
            commit('SET_DADOS_ENGENHARIA', dados)
        },

        verificarVersao() {
            axios.get('app/versao.txt', {
                headers: {
                    'Cache-Control': 'no-cache'
                }
            }).then((res) => {
                let versaoLida = res.data.replace(/[^a-zA-Z0-9.\-]/g, '')
                if (process.env.VUE_APP_VERSION != versaoLida) {
                    console.log("Versão do app: " + process.env.VUE_APP_VERSION + " | Versão do servidor: " + versaoLida)
                    window.location.reload();
                }
            });

        }
    },

    getters: {

        recarregar(state) {
            return state.recarregar
        },

        requestErro(state) {
            return state.requestErro
        },

        dadosEngenharia(state) {
            return state.dadosEngenharia
        }
    },

    modules: {
        loading,
        loginuser
    }
})
